import { I as IconWrapper, _ as _objectSpread2 } from '../../dist/Icon-3ba184f8.esm.js';
import 'react';
import { jsx, jsxs } from 'react/jsx-runtime';
import 'styled-components';
import '@lendi-ui/color';

function SvgDomainBot(props) {
  return /*#__PURE__*/jsx(IconWrapper, _objectSpread2(_objectSpread2({}, props), {}, {
    children: /*#__PURE__*/jsx("svg", {
      viewBox: "0 0 40 40",
      xmlns: "http://www.w3.org/2000/svg",
      children: /*#__PURE__*/jsxs("g", {
        fill: "none",
        fillRule: "evenodd",
        children: [/*#__PURE__*/jsx("path", {
          fill: "#0EA800",
          d: "M0 0h40v40H0z"
        }), /*#__PURE__*/jsxs("g", {
          fill: "#FFF",
          fillRule: "nonzero",
          children: [/*#__PURE__*/jsx("path", {
            d: "M19.394 8L10 14.191v.735-.554 17.45H20.999l1.094-1.672-1.094-1.67h-7.656V15.99h.001l6.05-3.987V8"
          }), /*#__PURE__*/jsx("path", {
            d: "M28.788 14.372v-.18L19.394 8v4.004l6.05 3.987v15.821h3.344v-17.44"
          })]
        })]
      })
    })
  }));
}

export { SvgDomainBot as default };
